import React from "react";
import styled from "styled-components";

import { Fonts } from "assets/fonts";

const NoItemsCopy = styled.p`
  margin: 32px auto;
  text-align: center;
  ${Fonts.regular_14}
  font-style: italic;
  color: ${(p) => p.theme.textMediumContrast};
`;

interface NoItemsProps {
  customText?: string;
}
export const NoItems = (props: NoItemsProps) => {
  const { customText } = props;
  return <NoItemsCopy>{customText || "No items"}</NoItemsCopy>;
};
